"use strict";

/**
 *
 * Trigets the modals withe the auto-popup class.
 *
 */

function onLoad() {
  $(".js-auto-popup").modal();
}

module.exports = {
  onLoad
};



// WEBPACK FOOTER //
// ./resources/js/libraries/booking-autopopup/booking-autopopup.js